export default __webpack_public_path__ + "static/media/two.520974b3.jpeg";